module.exports = __webpack_public_path__ + "img/icono-altavoz.a5ee51fc.svg";